import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsEquipmentSystem, PmsEquipmentSystem } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsEquipmentSystem>
    useData={usePmsEquipmentSystem}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
